import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Hero Section */}
      <section className="bg-organic-green py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Get in Touch 🍎
          </h1>
          <p className="text-xl text-green-100">
            We'd love to hear from you! Reach out for fresh fruit inquiries, bulk orders, or just to say hello.
          </p>
        </div>
      </section>

      {/* Contact Cards Section */}
      <section className="py-16 px-4 md:px-16 lg:px-24">
        <div className="max-w-6xl mx-auto">
          {/* Main Contact Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12 border-t-4 border-organic-green">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              🌴 Visit Our Farm
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Address */}
              <div className="flex items-start space-x-4 p-4 bg-green-50 rounded-lg">
                <div className="w-12 h-12 bg-organic-green rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">Farm Location</h3>
                  <p className="text-gray-600">1800 NW 160th St, Okeechobee, FL 34972</p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start space-x-4 p-4 bg-amber-50 rounded-lg min-w-0">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="min-w-0 overflow-hidden">
                  <h3 className="font-bold text-gray-800 mb-1">Email Us</h3>
                  <a href="mailto:sirifarmsfreshproduce@gmail.com" className="text-organic-green hover:underline break-all block text-sm sm:text-base">
                    sirifarmsfreshproduce@gmail.com
                  </a>
                </div>
              </div>

            </div>

            {/* Phone Numbers */}
            <div className="mt-8">
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">📞 Call Us</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <a href="tel:248-497-9083" className="flex items-center justify-center space-x-3 p-4 bg-green-100 hover:bg-green-200 rounded-lg transition-colors group">
                  <div className="w-10 h-10 bg-organic-green rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <span className="font-semibold text-gray-700 group-hover:text-organic-green">248 497-9083</span>
                </a>
                <a href="tel:952-465-8430" className="flex items-center justify-center space-x-3 p-4 bg-orange-100 hover:bg-orange-200 rounded-lg transition-colors group">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <span className="font-semibold text-gray-700 group-hover:text-orange-600">952 465-8430</span>
                </a>
                <a href="tel:972-733-1057" className="flex items-center justify-center space-x-3 p-4 bg-yellow-100 hover:bg-yellow-200 rounded-lg transition-colors group">
                  <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <span className="font-semibold text-gray-700 group-hover:text-yellow-600">972 733-1057</span>
                </a>
              </div>
            </div>
          </div>

          {/* Decorative Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Fresh Fruits Card */}
            <div className="bg-gradient-to-br from-red-100 to-pink-100 p-6 rounded-xl text-center">
              <div className="text-5xl mb-3">🍓</div>
              <h3 className="font-bold text-gray-800">Fresh Berries</h3>
              <p className="text-sm text-gray-600">Handpicked daily</p>
            </div>

            {/* Tropical Card */}
            <div className="bg-gradient-to-br from-yellow-100 to-orange-100 p-6 rounded-xl text-center">
              <div className="text-5xl mb-3">🥭</div>
              <h3 className="font-bold text-gray-800">Tropical Fruits</h3>
              <p className="text-sm text-gray-600">Exotic flavors</p>
            </div>

            {/* Organic Card */}
            <div className="bg-gradient-to-br from-green-100 to-emerald-100 p-6 rounded-xl text-center">
              <div className="text-5xl mb-3">🌿</div>
              <h3 className="font-bold text-gray-800">100% Organic</h3>
              <p className="text-sm text-gray-600">Farm to table</p>
            </div>
          </div>

          {/* Business Hours */}
          <div className="mt-12 bg-organic-green rounded-xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">🕐 Business Hours</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-md mx-auto">
              <div>
                <p className="font-semibold">Monday - Friday</p>
                <p className="text-green-100">8:00 AM - 6:00 PM</p>
              </div>
              <div>
                <p className="font-semibold">Saturday - Sunday</p>
                <p className="text-green-100">9:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;